export default __webpack_public_path__ + "static/media/vijaywadaHistoryOne.5b40c916.png";